import NotificationAndSystemModule from "./component";
export default NotificationAndSystemModule;